<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.status" placeholder="请选择状态" value-name="value" text-name="label" :columns="statusLists" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="$refs['tgbinvoicelisttable'].fetchTableData() ">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="tgbinvoicelisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.getTgbInvoiceList">
        <el-table-column label="机构名称" prop="company_name" align="center" />
        <el-table-column label="开票金额" align="center">
          <template slot-scope="{row}">
            {{ row.amount/100 }}
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="create_time" align="center" />
        <el-table-column label="审核时间" prop="modify_time" align="center" />
        <el-table-column label="审核状态" align="center">
          <template slot-scope="{row}">
            {{ getMapStatus(row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 2" type="primary" size="middle" @click="fnAudit(row)">审核</el-button>
          </template>
        </el-table-column>
      </wq-table>
      <el-dialog
        title="开票详情"
        :visible.sync="dialogVisible"
        width="500px"
        class="order-detail-dialog"
      >
        <div v-if="invoiceCompany" class="company_info">
          <b>开票信息</b>
          <div class="flex-wrap element_margin_top">
            <div class="element_margin_right">抬头类型:</div>
            <div>公司类型</div>
          </div>
          <div class="flex-wrap">
            <div class="element_margin_right">发票抬头:</div>
            <div v-if="invoiceCompany.invoice_title ">{{ invoiceCompany.invoice_title }}</div>
          </div>
          <div v-if="invoiceCompany.invoice_title" class="flex-wrap">
            <div class="element_margin_right">发票税号:</div>
            <div>{{ invoiceCompany.invoice_tax_number }}</div>
          </div>
          <div class="flex-wrap">
            <div class="element_margin_right">发票内容:</div>
            <div>托管宝使用服务费</div>
          </div>
          <div class="flex-wrap flex_middle">
            <div class="element_margin_right">开票金额:</div>
            <div class="danger-font-color">{{ (invoiceCompany.amount || 0 )/100 }}元</div>
          </div>
          <div v-if="invoiceCompany.invoice_title" class="flex-wrap">
            <div class="element_margin_right">接受邮箱:</div>
            <div>{{ invoiceCompany.email }}</div>
          </div>
        </div>
        <el-input
          v-model="auditPostForm.remark"
          style="margin-top: 10px;"
          type="textarea"
          :rows="3"
          placeholder="请输入备注内容"
        />
        <div slot="footer" class="dialog-footer">
          <el-button type="danger" @click="fnSubmitAudit(3)">拒绝</el-button>
          <el-button type="primary" @click="fnSubmitAudit(4)">开票完成</el-button>

        </div>
      </el-dialog>
    </div>

  </div>

</template>
<script>

import WqTable from '@/components/WqTable'
import WqSelect from '@/components/FormBox/WqSelect'
import Tool from '@/assets/js/tool.js'

const INVOICE_STATUS_MAP = [
  {
    value: '2',
    label: '待财务审核'
  },
  {
    value: '3',
    label: '已拒绝'
  },
  {
    value: '4',
    label: '已开票'
  }
]

const defaultAuditPostForm = {
  status: '',
  id: '',
  remark: ''
}
export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    WqSelect
  },

  data() {
    return {
      listQuery: {
        shop_id: '',
        status: '2',
        purchase_type: ''
      },
      invoiceCompany: '',
      statusLists: INVOICE_STATUS_MAP,
      dialogVisible: false,
      auditPostForm: Object.assign({}, defaultAuditPostForm)
    }
  },
  created() {
  },
  methods: {

    getMapStatus(status) {
      const index = Tool.findIndexInArryByKeyVal(INVOICE_STATUS_MAP, 'value', status)
      return index > -1 ? INVOICE_STATUS_MAP[index].label : ''
    },
    fnAudit(row) {
      this.auditPostForm = Object.assign({}, defaultAuditPostForm, {
        id: row.id
      })
      this.invoiceCompany = row
      this.dialogVisible = true
    },
    fnSubmitAudit(status) {
      if (status === 3 && !this.auditPostForm.remark) {
        this.$message.error('请填写拒绝原因')
        return
      }
      this.auditPostForm.status = status
      this.$http.auditTgbInvoice(this.auditPostForm).then((res) => {
        if (res.code == 200) {
          this.$message.success(`开票${status === 2 ? '同意' : '拒绝'}成功`)
          this.dialogVisible = false
          this.$refs.tgbinvoicelisttable.fetchTableData()
        }
      })
    }

  }
}
</script>
  <style lang="scss">
  .company_info {
    b {
      font-size: 17px;

    }
    .flex-wrap {
        margin-top: 5px;
        font-size: 16px;
        .danger-font-color {
          font-size: 17px;
        }
      }
  }
  .element_margin_right {
    margin-right: 5px;
  }
  .element_margin_top {
    margin-top: 5px
  }
  .el-image-viewer__wrapper .el-icon-circle-close {
    color:white
  }
    .food-search {
    .tuolele-main-search-item {
      margin-bottom: 0;
      padding: 0;
      border: 0;
      .el-form--inline .el-form-item {
        display: block;
      }
      .split-time{
        margin-right: 20px;
      }
      .el-select,
      .el-input {
        width: 160px !important;
        margin-right: 20px;
      }
      span.select-date {
        margin-right: 10px;
      }
      .button-group {
        margin-left: 82px;
      }
    }
  }
  </style>
